<template>
    <div class="ds-tabs" :style="tabsStyle">
        <div class="ds-tabs-list">
            <button
                v-for="tab in tabs"
                :key="tab.name"
                class="ds-tabs-link"
                :class="{ 'ds-tabs-link-active': tab.name === selectedTab, 'ds-tabs-link-disabled': tab.disabled }"
                :disabled="tab.disabled"
                @click="selectTab(tab)"
            >
                {{ tab.label }}
            </button>
        </div>
        <div class="ds-tabs-panel">
            <slot :name="selectedTab"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { Tab } from '@/types';

const props = defineProps<{
    initialTab?: string;
    tabs: Tab[];
    tabFontSize?: string;
    px?: string;
    borderBottomWidth?: string;
    tabMarginRight?: string
}>();

const tabsStyle = computed(() => ({
    '--ds-tabs-px': `${props.px ?? 0}px`,
    '--ds-tabs-border-width': `${props.borderBottomWidth ?? 1}px`,
    '--ds-tabs-font-size': `${props.tabFontSize ?? 16}px`,
    '--ds-tabs-gap': `${props.tabMarginRight ?? 22}px`
}))

const selectedTab = ref(props.initialTab || (props.tabs.length ? props.tabs[0].name : ''));

const selectTab = (tab: Tab) => {
    if(tab.disabled) return
    selectedTab.value = tab.name;
};

// Watch for changes in initialTab prop and update selectedTab accordingly
watch(() => props.initialTab, (newVal) => {
    if (newVal && props.tabs.find(tab => tab.name === newVal)) {
        selectedTab.value = newVal;
    }
});
</script>
